<template>
  <div class="assignment-form">
    <div class="header-section">
      <div class="title">
        {{ assignmentContractorProfile.displayName }}
      </div>
      <div class="info">
        <div class="label">
          {{ $t('contractor.labels.payrollNumber') }}
        </div>
        <div>{{ assignmentContractorProfile.payrollNumber }}</div>
        <div class="label">Contractor</div>
        <div class="contact">
          <a :href="`mailto:${assignmentContractorProfile.email}`">
            <div>{{ assignmentContractorProfile.displayName }}</div>
            <div>
              <font-awesome-icon icon="envelope" />
              {{ assignmentContractorProfile.email }}
            </div>
            <div v-if="assignmentContractorProfile.phone">
              <font-awesome-icon icon="phone-square" />
              {{ assignmentContractorProfile.phone }}
            </div>
          </a>
        </div>
      </div>
    </div>

    <div class="header-section">
      <div class="title">
        {{ assignment.client_name }}
      </div>
      <div class="info cc">
        <div class="label">Approvers</div>
        <div v-for="approver in approvers" :key="approver.id" class="contact">
          <a :href="`mailto:${approver.email}`">
            <div>{{ approver.displayName }}</div>
            <div>
              <font-awesome-icon icon="envelope" />
              {{ approver.email }}
            </div>
          </a>
        </div>
      </div>
      <div v-if="viewers.length > 0" class="info cc">
        <div class="label">Viewers</div>
        <div v-for="viewer in viewers" :key="viewer.id" class="contact">
          <a :href="`mailto:${viewer.email}`">
            <div>{{ viewer.displayName }}</div>
            <div>
              <font-awesome-icon icon="envelope" />
              {{ viewer.email }}
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="header-section">
      <div class="title">
        {{ $t('assignment.details.title') }}
      </div>
      <div class="info">
        <div class="label">Branch</div>
        <div>{{ assignment.branch_name }} {{ assignment.division_abbr }}</div>
        <div class="label">Start</div>
        <div><font-awesome-icon icon="calendar-alt" /> {{ assignment.start_date }}</div>
        <div class="label">Stop</div>
        <div><font-awesome-icon icon="calendar-alt" /> {{ assignment.stop_date }}</div>
        <div class="label">Submittal period</div>
        <div>{{ assignment.submittal_period_type | readable | capitalize }}</div>
        <div class="label">Pay period</div>
        <div>{{ assignment.pay_period_type | readable | capitalize }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as R from 'ramda';
import { mask } from '@/mixins/mask';

export default {
  name: 'AssignmentHeader',
  mixins: [mask],
  props: {
    assignment: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      formData: {},
      isNewPayorll: false,
      revealHST: false
    };
  },
  computed: {
    telephone: {
      get() {
        return this.assignment.contractor.phone1 + `(${this.assignment.contractor.phone1_type})`;
      }
    },
    assignmentContractorProfile() {
      let contractor_profile = {
        displayName: this.assignment.contractor.contractor_name,
        email: this.assignment.contractor.email,
        payrollNumber: this.assignment.payroll_number,
        phone: this.assignment.contractor.phone1
      };
      return contractor_profile;
    },
    approvers() {
      const res = this.assignment.stakeholderClientContacts
        .filter(contact => contact.can_approve_time_sheets)
        .map(item => {
          return {
            id: item.user_id,
            displayName: item.display_name,
            email: item.email
          };
        });
      return res;
    },
    viewers() {
      const res = this.assignment.stakeholderClientContacts
        .filter(contact => !contact.can_approve_time_sheets && contact.can_view_time_sheets)
        .map(item => {
          return {
            id: item.user_id,
            displayName: item.display_name,
            email: item.email
          };
        });
      return res;
    },
    privatizedHST: {
      get() {
        if (this.revealHST) return this.assignment.contractor.hst;
        else
          return this.assignment.contractor.hst
            ? this.maskHSTOrGSTOrQST(this.assignment.contractor.hst)
            : '';
      }
    },
    payrollNums() {
      let arr = this.formData.payrollNums.map(numbers => numbers.payroll_number);
      arr = ['Add New'].concat(arr);
      return arr;
    }
  },
  watch: {
    assignment: {
      immediate: true,
      handler() {
        this.formData = R.clone(this.assignment);
        let contractorObj = this.formData.contractor;
        if (contractorObj.line1) {
          this.formData.contractor.address = {
            address_line1: contractorObj.line1,
            address_line2: contractorObj.line2,
            city: contractorObj.city,
            postal_code: contractorObj.postal_code,
            province_abbr: contractorObj.province_abbr
          };
        }
        if (this.formData.ibmExtraInfo) {
          this.ibmExtraInfo = this.formData.ibmExtraInfo;
        }
      }
    }
  },
  methods: {
    onToggleReveal() {
      this.revealHST = !this.revealHST;
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';
@import '@/app/styles/action-buttons.scss';

.assignment-form {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 15px;

  .header-section {
    .title {
      border-bottom: 1px solid $row-border;
      margin-bottom: 15px;
      font-size: 18px;
    }

    .info {
      div {
        margin-bottom: 5px;
      }
      display: grid;
      grid-template-columns: 1fr 1fr;
      &.cc {
        grid-template-columns: 1fr;
      }
      .label {
        font-weight: bold;
      }

      .contact {
        display: flex;
        flex-direction: column;
        padding: 8px;
        border: 1px solid #fff;
        &:hover {
          cursor: pointer;
          border: 1px solid #ccc;
          border-radius: 5px;
          background-color: $yellow;
        }

        a {
          text-decoration: none;
          color: inherit;
        }
      }
    }
  }
}
</style>
